import { type TFunction } from 'i18next'

import {
  diffFiveNumbers,
  type FiveSegment,
  type FiveSegmentCounts,
  fiveSegmentLabelI18nKeyMap,
  fiveSegments,
} from '~/utils'

export const fiveSegmentIndicators = [
  // ロイヤル vs 認知未購入
  'loyalVsRecognized',
  // ロイヤル vs 離反
  'loyalVsEstranged',
  // ロイヤル vs 一般
  'loyalVsGeneral',
  // 一般 vs 認知未購入
  'generalVsRecognized',
  // 一般 vs 離反
  'generalVsEstranged',
] as const
export type FiveSegmentIndicator = (typeof fiveSegmentIndicators)[number]

// eslint-disable-next-line jsdoc/require-param, jsdoc/require-returns
/**
 * TODO: [i18n改善] t関数を引数で受け取る設計を見直す
 * 翻訳キーを返し、呼び出し側でt()を適用する形に変更することで、保守性の改善を行う
 */
export const createFiveSegmentIndicatorLabelMap = (t: TFunction) => ({
  loyalVsRecognized: `${t(fiveSegmentLabelI18nKeyMap.fiveSegment1)}\nvs\n${t(fiveSegmentLabelI18nKeyMap.fiveSegment4)}`,
  loyalVsEstranged: `${t(fiveSegmentLabelI18nKeyMap.fiveSegment1)}\nvs\n${t(fiveSegmentLabelI18nKeyMap.fiveSegment3)}`,
  loyalVsGeneral: `${t(fiveSegmentLabelI18nKeyMap.fiveSegment1)}\nvs\n${t(fiveSegmentLabelI18nKeyMap.fiveSegment2)}`,
  generalVsRecognized: `${t(fiveSegmentLabelI18nKeyMap.fiveSegment2)}\nvs\n${t(fiveSegmentLabelI18nKeyMap.fiveSegment4)}`,
  generalVsEstranged: `${t(fiveSegmentLabelI18nKeyMap.fiveSegment2)}\nvs\n${t(fiveSegmentLabelI18nKeyMap.fiveSegment3)}`,
})

export type FiveSegmentColumnKey =
  | FiveSegment
  | FiveSegmentIndicator
  | 'answerNumber'
  | 'answerText'
  | 'generalPad'
  | 'loyalPad'
  | 'questionText'
  | 'total'

export const fiveSegmentSortColumnKeys = [
  'total',
  ...fiveSegments,
  ...fiveSegmentIndicators,
] as const satisfies readonly FiveSegmentColumnKey[]
export type FiveSegmentSortColumnKey =
  (typeof fiveSegmentSortColumnKeys)[number]

export const fiveSegmentDisplayColumnKeys = [
  'total',
  ...fiveSegments,
  ...fiveSegmentIndicators,
] as const satisfies readonly FiveSegmentColumnKey[]
export type FiveSegmentDisplayColumnKey =
  (typeof fiveSegmentDisplayColumnKeys)[number]

export const calcFiveSegmentIndicatorCounts = (
  fiveSegmentCounts: FiveSegmentCounts,
): Record<FiveSegmentIndicator, number> => ({
  loyalVsRecognized: diffFiveNumbers(fiveSegmentCounts, 1, 4),
  loyalVsEstranged: diffFiveNumbers(fiveSegmentCounts, 1, 3),
  loyalVsGeneral: diffFiveNumbers(fiveSegmentCounts, 1, 2),
  generalVsRecognized: diffFiveNumbers(fiveSegmentCounts, 2, 4),
  generalVsEstranged: diffFiveNumbers(fiveSegmentCounts, 2, 3),
})

export type FiveSegmentsData = {
  counts: Record<FiveSegment | FiveSegmentIndicator | 'total', number>
  ratios: Record<FiveSegment | FiveSegmentIndicator | 'total', number>
}
